/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CRC_COUPONS_ITEM = {
  id: 'coupons',
  screenId: 'fin-crc-coupons',
  label: 'Cupones',
  description: 'Cupones de cobros con tarjeta registrados en el sistema.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá ves los cupones que se generaron al cobrar con tarjeta en ventas o cobros. Cada cupón representa una operación con tarjeta (Visa, Mastercard, etc.) registrada en el sistema.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Los cupones se crean automáticamente cuando registrás un cobro con tarjeta (recibo de cobro con medio «tarjeta»). No se cargan manualmente desde esta pantalla.',
          'Necesitás terminales POS configurados y permisos sobre ellos. El selector de proveedor muestra solo las procesadoras de tus terminales autorizados.',
          'Orden recomendado del módulo: Configuración → Cupones (consulta) → Control de cupones → Liquidaciones.',
        ],
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          {
            label: 'Proveedor',
            description: 'Procesadora de tarjetas (Prisma, Fiserv, etc.) según tus terminales POS. No es un proveedor de compras.',
          },
          {
            label: 'Fecha desde / Fecha hasta',
            description: 'Período de los cupones. Por defecto suele mostrarse la última semana.',
          },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Fecha, Marca, Cupón (número), Lote, Controlado, Monto.',
          'Controlado — ícono verde si el cupón ya fue vinculado en «Control de cupones»; rojo si aún no.',
          'Tocá una fila para ver el detalle (recibo de cobro asociado, cliente, etc.).',
          'Solo los cupones no controlados muestran papelera para eliminar (revierte el cobro vinculado).',
        ],
      },
    ],
  },
}
